export default "/_next/static/sponsored-event.svg";